import { config } from './config';

/*
export function bootUser() {
    // var refreshNow = "0; url='" + config.fullLoginURI + "'";
    var refreshNow = "0; url='" + config.logoutURI + "'";
    return(
    <div>
    <meta http-equiv="refresh" content={refreshNow} /> 
    <center>Your login has expired.  <a href={config.fullLoginURI}>Please click to login</a></center>
    </div>
    )
}
*/
export function bootUser() {
    return(
    <div>
    <center>Your login has expired.  <a href={config.fullLoginURI}>Please click to login</a></center>
    </div>
    )
}